<script setup lang="ts">
import type { CarouselProps } from '#ui/types';
import lodashOmit from 'lodash-es/omit';

export interface StoryblokUiCarouselProps {
    blok: StoryblokUiCarousel;
}

// PROPS
const { blok } = defineProps<StoryblokUiCarouselProps>();

// DATA
const carouselProps = computed<Omit<CarouselProps, 'items'>>(() =>
    lodashOmit(storyblokOmitEmptyValues<StoryblokUiCarousel>(blok), ['_uid', 'items', 'itemsPerPage'])
);
const ui = computed(() => {
    switch (blok.itemsPerPage) {
        case '2':
            return { item: 'basis-1/2' };
        case '3':
            return { item: 'basis-1/3' };
        case '4':
            return { item: 'basis-1/4' };
    }

    return {};
});
</script>

<template>
    <UCarousel v-slot="{ item }" v-editable="blok" v-bind="carouselProps" :items="blok.items ?? []" :ui="ui">
        <StoryblokComponent :blok="item" />
    </UCarousel>
</template>
